import { useState } from 'react'
import { Trans } from 'react-i18next'

import { Edit16 } from '@makyoapp/makyo-icon/icon'

import { useGridV2Context } from '@/components/GridV2/contexts/GridV2Context'

import { ModalEditTable } from '../Modal/ModalEditTable'

export const RenameTable = () => {
  const { table } = useGridV2Context()
  const [show, setShow] = useState(false)

  if (!table) return null

  return (
    <>
      <button onClick={() => setShow(true)} className='mk-ddi flex-c mk-dd-row'>
        <Edit16 />
        <div>
          <Trans>Rename {table.isSnapshot ? 'Snapshot' : table.isQuery ? 'Query' : 'Table'}</Trans>
        </div>
      </button>
      <ModalEditTable show={show} setShow={setShow} />
    </>
  )
}
